@if (approxSymbol()) {
  <span [class.disabled]="true" [ngClass]="approxSymbolClass()">{{approxSymbol()}}</span>
}
@if (signSymbol()) {
  <span [ngClass]="signSymbolClass()">{{signSymbol()}}</span>
}
@if (currencySymbol()) {
  <span [ngClass]="currencySymbolClass()">{{currencySymbol()}}</span>
}
<span [ngClass]="valueClass()">
  <span [ngClass]="intValueClass()">{{int() | number:'1.0':locale()}}</span>
  @if (cent()) {
    <span [ngClass]="centValueClass()">{{dot()}}{{cent()}}</span>
  }
</span>
